import { Link } from 'react-router-dom';

export default function CockpitClearanceSection() {
  return (
    <section className="relative py-12 sm:py-20 overflow-hidden bg-gradient-to-b from-[#0A1628] to-[#060E1E]">
      {/* Subtle grid background */}
      <div className="absolute inset-0 opacity-5"
        style={{ backgroundImage: 'linear-gradient(#00FFD1 1px, transparent 1px), linear-gradient(90deg, #00FFD1 1px, transparent 1px)', backgroundSize: '40px 40px' }}
      />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10">
        {/* Heading */}
        <h2 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-center mb-6 leading-tight">
          Cockpit clearance for<br />
          <span className="text-[#00FFD1]">every phase of flight.</span>
        </h2>
        <p className="text-center text-gray-400 text-base sm:text-lg mb-12 sm:mb-16 max-w-3xl mx-auto leading-relaxed">
          From preflight to pattern work, WingmanFix gives you real-time feedback, scoring, and coaching insights—so you can fly smarter, safer, and with confidence.
        </p>

        {/* Feature grid */}
        <div className="grid md:grid-cols-2 gap-8 lg:gap-16 mb-12 sm:mb-20">
          {[
            {
              icon: 'ri-checkbox-circle-line',
              title: 'Preflight Inspection',
              desc: 'Digital checklists that adapt to your aircraft and weather conditions.',
            },
            {
              icon: 'ri-radio-line',
              title: 'Live Radio Transcription',
              desc: 'Real-time ATC transcription and playback for post-flight review.',
            },
            {
              icon: 'ri-line-chart-line',
              title: 'Flight Scoring & Analysis',
              desc: 'Get instant performance scores on altitude, heading, speed, and pattern work.',
            },
            {
              icon: 'ri-lightbulb-line',
              title: 'Coaching Insights',
              desc: 'Personalized tips from your AI copilot after every flight.',
            },
          ].map((feature) => (
            <div key={feature.title} className="flex gap-4 sm:gap-6 items-start bg-white/5 border border-white/10 rounded-xl p-5 sm:p-6 hover:bg-white/8 hover:border-[#00FFD1]/30 transition-all">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#00FFD1]/10 rounded-lg border border-[#00FFD1]/30 flex-shrink-0">
                <i className={`${feature.icon} text-[#00FFD1] text-xl sm:text-2xl`} />
              </div>
              <div>
                <h3 className="text-lg sm:text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-sm sm:text-base text-gray-400 leading-relaxed">{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Stats bar */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6 mt-12 sm:mt-20 bg-white/5 border border-[#00FFD1]/20 rounded-xl p-6 sm:p-8">
          {[
            { value: '94%', label: 'Accuracy Rate' },
            { value: '3x', label: 'Faster Progress' },
            { value: '500+', label: 'Flights Analyzed' },
            { value: '4.9/5', label: 'Pilot Rating' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#00FFD1] mb-1">{stat.value}</div>
              <div className="text-xs sm:text-sm text-gray-400 uppercase tracking-wider">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12 sm:mt-16">
          <Link
            to="/features"
            className="inline-flex items-center gap-2 bg-[#00A3E0] hover:bg-[#0088BB] text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg transition-all font-bold text-base sm:text-lg shadow-xl hover:shadow-[#00A3E0]/40 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <span>Explore All Features</span>
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}